<nz-select
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  [nzMode]="nzMode"
  [nzPlaceHolder]="placeholder"
  [nzAllowClear]="allowClear"
  [nzShowSearch]="true"
  [nzDisabled]="isDisabled"
  (nzOnSearch)="onSearch($event)"
  (nzOpenChange)="!$event && onBlur()"
  [nzNotFoundContent]="notFoundTpl"
  class="rdm-select">
  <nz-option *ngFor="let opt of options" [nzValue]="opt.code" [nzLabel]="opt.label"></nz-option>
</nz-select>

<ng-template #notFoundTpl>
  <div class="not-found-content">
    No matches found.
    <a *ngIf="searchText && rdmTypeLabel && canAdd" (click)="openModal()" class="add-link">
      Add '{{ searchText }}'
    </a>
  </div>
</ng-template>

<nz-modal
  [(nzVisible)]="modalVisible"
  nzTitle="Add Value"
  [nzFooter]="modalFooter"
  (nzOnCancel)="closeModal()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="addForm" [nzLayout]="'vertical'">
      <nz-form-item>
        <nz-form-label nzRequired>Code</nz-form-label>
        <nz-form-control [nzValidateStatus]="addForm.get('code')!" [nzErrorTip]="addForm.get('code')?.hasError('required') ? 'Code is required' : addForm.get('code')?.hasError('minlength') ? 'Minimum 3 characters required' : addForm.get('code')?.hasError('maxlength') ? 'Maximum 100 characters allowed' : ''">
          <nz-switch
            [ngModel]="autoGenerateCode"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="toggleAutoGenerate($event)"
            nzCheckedChildren="Auto"
            nzUnCheckedChildren="Auto">
          </nz-switch>
          <ng-container *ngIf="!autoGenerateCode">
            <input nz-input formControlName="code" placeholder="Enter Code" maxlength="100" class="code-input" />
            <small class="form-text text-muted">
              <code>{{ addForm.get('code')?.value?.length || 0 }}</code> of <code>100</code> characters
            </small>
          </ng-container>
          <ng-container *ngIf="autoGenerateCode">
            <small class="form-text text-muted code-char-info">
              <code>{{ addForm.getRawValue().code?.length || 0 }}</code> of <code>100</code> characters
            </small>
          </ng-container>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzRequired>Description</nz-form-label>
        <nz-form-control [nzValidateStatus]="addForm.get('description')!" [nzErrorTip]="addForm.get('description')?.hasError('required') ? 'Description is required' : addForm.get('description')?.hasError('minlength') ? 'Minimum 3 characters required' : addForm.get('description')?.hasError('maxlength') ? 'Maximum 200 characters allowed' : ''">
          <input nz-input formControlName="description" placeholder="Enter Description" maxlength="200" />
          <small *ngIf="addForm.get('description')?.value" class="form-text text-muted">
            <code>{{ addForm.get('description')?.value?.length || 0 }}</code> of <code>200</code> characters
          </small>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="closeModal()">Cancel</button>
    <button nz-button nzType="primary"
      [disabled]="addForm.get('description')!.invalid || (!autoGenerateCode && addForm.get('code')!.invalid)"
      [nzLoading]="modalLoading"
      (click)="submit()">Submit</button>
  </ng-template>
</nz-modal>
